import { Time } from '@angular/common';
import { OnlinePayResModel } from './OnlinePayResModel';

export class ParkBookingDetailsModel{
	pk:number;
	applicantId:number;
	applicantType:number;
	activityType:number;
	applicantName:string;
	recommendedName:string;
	recommendedDesignation:string;
	recommendedContact:string;
	organizationalRepresentative:string;
	organizationalRepresentative1:string;
	adharCardNumber:string;
	aadharCardDoc:string;
	applicantAddress:string;
	applicantMobileNo:number;
	applicantEmailId:string;
	facilityCategory:string;
	expectedCrowd:number;
	confirmationCopy:string;
	facilityToBeBooked:string;
	areaOfTheParkedBooked:string;
	dateOfBooking:Date;
	daySlot:string;
	listOfProposedActivities:string;
	selectedElectricity:string;
	eventTheme:string;
	estimatedNumberOfGuests:string;
	proposalOfFood:string;
	ticketPlan:string;
	timeFrom:Time;
	timeTo:Time;
	numberOfExecpectedGuest:string;
	securityPersonnelDeployment:string;
	arrangementofGuestParkingPlans:string;
	selectedEduInsti:string;
	bookingDuration:string;
	electricCharges:number;
	hiringCharges:number;
	securityAmount:number;
	AcceptedTerm:boolean;
	applicationNo:string;
	totalCharge:number;
	hiringCharge:number;
	electricCharge:number;
	ticketcharge:number;
	securityAmounts:number;
	cgst:number;
	sgst:number;
	toTimeOfBooking:string;
	fromTimeOfBooking:string;
	refundedAmount:string;
	entryTicket:number;
	accHolderName:string;
	bankName:string;
	branchName:string;
	ifscCode:string;
	bankAccountNo:string;
	educationlInsitute:number;
	bookingCharge:number;
	discount:string;
	maximumCapacity:string;
	daySubSlot:string;
	anyOtherDoc:string
	damageCharge:number;
	damageDescription:string;
	totalRefund:number;
	zone:number;

	onlinePayResModel:Array<OnlinePayResModel>

	
}